import React from 'react';
import { Flex, Stack, VStack, CheckboxGroup, Heading } from '@chakra-ui/react';
import { FabricAttributes as fa } from 'product-validator';
import { AppFieldComponent } from '../../../../types';
import { CommonUsesField, CommonUsesOptions } from '../CommonUsesField';

export const FabricUsesField: AppFieldComponent = (props) => {
  let occasionCheckboxOptions;
  let occasionCategoryOptions = Object.entries(fa.OccasionUntagged);

  let constructionCheckboxOptions;
  let constructionCategoryOptions = Object.entries(fa.ConstructionUseUntagged);

  let seasonCheckboxOptions;
  let seasonCategoryOptions = Object.entries(fa.SeasonTagged);

  occasionCheckboxOptions = occasionCategoryOptions.map(
    ([occasionCategory, occasionCategoryItems]) => (
      <CommonUsesOptions
        key={occasionCategory}
        useCategory={occasionCategory}
        title={occasionCategory}
        options={Object.values(occasionCategoryItems)}
      />
    )
  );

  constructionCheckboxOptions = constructionCategoryOptions.map(
    ([constructionCategory, constructionCategoryItems]) => (
      <CommonUsesOptions
        key={constructionCategory}
        useCategory={constructionCategory}
        title={constructionCategory}
        options={Object.values(constructionCategoryItems)}
      />
    )
  );

  seasonCheckboxOptions = seasonCategoryOptions.map(
    ([seasonCategory, seasonCategoryItems]) => (
      <CommonUsesOptions
        key={seasonCategory}
        useCategory={seasonCategory}
        title={seasonCategory}
        options={Object.values(seasonCategoryItems)}
      />
    )
  );

  return (
    <VStack spacing="8" alignItems="left">
      <CommonUsesField {...props} />
      <Heading>Occasion</Heading>
      <Stack spacing="3">
        <CheckboxGroup
          value={props.currentValue.usesOccasion}
          onChange={(occasionArr: string[]) => {
            props.setFormField({
              usesOccasion: occasionArr
            });
          }}
        >
          <Flex
            flexDirection="row"
            wrap="wrap"
            maxW="60rem"
            sx={{ gap: '0.25rem' }}
          >
            {occasionCheckboxOptions}
          </Flex>
        </CheckboxGroup>
      </Stack>
      <Heading>Construction Use</Heading>
      <Stack spacing="3">
        <CheckboxGroup
          value={props.currentValue.usesConstruction}
          onChange={(constructionArr: string[]) => {
            props.setFormField({
              usesConstruction: constructionArr
            });
          }}
        >
          <Flex
            flexDirection="row"
            wrap="wrap"
            maxW="60rem"
            sx={{ gap: '0.25rem' }}
          >
            {constructionCheckboxOptions}
          </Flex>
        </CheckboxGroup>
      </Stack>
      <Heading>Season</Heading>
      <Stack spacing="3">
        <CheckboxGroup
          value={props.currentValue.usesSeason}
          onChange={(seasonArr: string[]) => {
            props.setFormField({
              usesSeason: seasonArr
            });
          }}
        >
          <Flex
            flexDirection="row"
            wrap="wrap"
            maxW="60rem"
            sx={{ gap: '0.25rem' }}
          >
            {seasonCheckboxOptions}
          </Flex>
        </CheckboxGroup>
      </Stack>
    </VStack>
  );
};
